import BaseModule from '@/store/baseModule';
import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import BaseModulePlugins from '@/store/baseModule/plugins';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';

export default (store) => {
  store.registerModule(
    ['requests', 'history', 'reason'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.P2C_BASE_URI}/diagnostic_qualifications`,
        }),
      }),
      makeQueryParams: makeListRequest({}),
      searchAttributesArray: ['diagnostic_qualif_name'],
    })
  );
  const basePlugin = new BaseModulePlugins({
    module: 'requests/history/reason',
    store,
  });

  basePlugin.onInit(() => {
    store.dispatch('requests/history/reason/setItemsPageSize', 3);
  });
};
